module.exports = __webpack_public_path__ + "6fac0de9df16ddd49978c1cec2086ce0.fbx";